import Alpine from "alpinejs";

// AlpineJS Plugins
import persist from "@alpinejs/persist"; // @see https://alpinejs.dev/plugins/persist
import collapse from "@alpinejs/collapse"; // @see https://alpinejs.dev/plugins/collapse
import intersect from "@alpinejs/intersect"; // @see https://alpinejs.dev/plugins/intersect
import focus from '@alpinejs/focus';

// Third Party Libraries

/*
    Scrollbar Library
    @see https://github.com/Grsmto/simplebar
*/
import SimpleBar from "simplebar";

/*
    Code highlighting library
    Just for demo purpose only for highlighting code
    @see https://highlightjs.org/
*/
import hljs from "highlight.js/lib/core";
import xml from "highlight.js/lib/languages/xml";

/*
    Date Utility Library
    @see https://day.js.org/
*/
import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/es'; // Importa el español

import { Str } from 'laravel-js-str';
window.Str = Str;

dayjs.extend(relativeTime);
dayjs.locale('es'); // Configura el idioma globalmente

window.dayjs = dayjs; // Hazlo global para usarlo en Alpine

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

/*
    Carousel Library
    @see https://swiperjs.com/
*/
import Swiper from "swiper/bundle";

/*
    Drag & Drop Library
    @see https://github.com/SortableJS/Sortable
*/
import Sortable from "sortablejs";

/*
    Charts Libraries
    @see https://apexcharts.com/
*/
import ApexCharts from "apexcharts";

/*
    Tables Libraries
    @see https://gridjs.io/
*/
import * as Gridjs from "gridjs";

//  Forms Libraries
import "@caneara/iodine"; // @see https://github.com/caneara/iodine
import * as FilePond from "filepond"; // @see https://pqina.nl/filepond/
import FilePondPluginImagePreview from "filepond-plugin-image-preview"; // @see https://pqina.nl/filepond/docs/api/plugins/image-preview/

import flatpickr from "flatpickr"; // @see https://flatpickr.js.org/
import Tom from "tom-select/dist/js/tom-select.complete.min"; // @see https://tom-select.js.org/

// Import Fortawesome icons
import "@fortawesome/fontawesome-free/css/all.css";

// Helper Functions
import * as helpers from "./utils/helpers";

// Pages Scripts
import * as pages from "./pages";

// Global Store
import store from "./store";

// Breakpoints Store
import breakpoints from "./utils/breakpoints";

// Alpine Components
import usePopper from "./components/usePopper";
import accordionItem from "./components/accordionItem";

// Alpine Directives
import tooltip from "./directives/tooltip";
import inputMask from "./directives/inputMask";

// Alpine Magic Functions
import notification from "./magics/notification";
import clipboard from "./magics/clipboard";

import Swal from 'sweetalert2';

import intlTelInput from 'intl-tel-input';

import Quill from 'quill';
// CORRECCIÓN: Importamos todo el módulo para que registre el plugin automáticamente
import {Mention, MentionBlot} from "quill-mention";
// 1. Importar los estilos CSS necesarios
import 'quill-mention/dist/quill.mention.min.css';

// 2. Hacer disponible Quill de manera global para tus Blots y vistas locales
//window.Quill = Quill;

// 3. Tus Blots y Editores personalizados locales (No deben llevar imports internos de Quill)
import "./components/quillFileBlot";
import quillAgreementEditor from "./components/quillAgreementEditor";

// 4. Exportar tu editor personalizado para que Alpine lo vea
window.quillAgreementEditor = quillAgreementEditor;

//import 'quill/dist/quill.snow.css';
//import 'quill-mention/dist/quill.mention.min.css';
import "quill-mention/autoregister";


import "./ckeditor-app-js-snippet";


// Register HTML, XML language for highlight.js
// Just for demo purpose only for highlighting code
hljs.registerLanguage("xml", xml);
hljs.configure({ ignoreUnescapedHTML: true });

// Register plugin image preview for filepond
FilePond.registerPlugin(FilePondPluginImagePreview);

window.hljs = hljs;
window.dayjs = dayjs;
window.SimpleBar = SimpleBar;
window.Swiper = Swiper;
window.Sortable = Sortable;
window.ApexCharts = ApexCharts;
window.Gridjs = Gridjs;
window.FilePond = FilePond;
window.flatpickr = flatpickr;
window.Quill = Quill;
window.Tom = Tom;
window.Swal = Swal;
window.intlTelInput = intlTelInput;

window.Alpine = Alpine;
window.helpers = helpers;
window.pages = pages;

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
    wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    forceTLS: (import.meta.env.VITE_REVERB_PROTOCOL ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
//    withCredentials: true, 
//    auth: {
//        headers: {
//            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
//        }
//    }
});

// Esperamos a que Echo se conecte y obtenga su ID único del servidor Reverb
window.Echo.connector.pusher.connection.bind('connected', () => {
    const socketId = window.Echo.socketId();
    
    // Si usas Axios para tus peticiones POST en la web:
    if (window.axios) {
        window.axios.defaults.headers.common['X-Socket-ID'] = socketId;
    }
    
    console.log("Reverb conectado con éxito. Socket ID registrado en Axios:", socketId);
});

Alpine.plugin(persist);
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(focus);

Alpine.directive("tooltip", tooltip);
Alpine.directive("input-mask", inputMask);

Alpine.magic("notification", () => notification);
Alpine.magic("clipboard", () => clipboard);

Alpine.store("breakpoints", breakpoints);
Alpine.store("global", store());

Alpine.data("usePopper", usePopper);
Alpine.data("accordionItem", accordionItem);
Alpine.data('quillAgreementEditor', quillAgreementEditor);

// Configuramos el mixin base
const ToastMixin = Swal.mixin({
    title: '',
    icon: 'success',
    toast: true,
    position: 'top-start',
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});

// Creamos un helper global con parámetros opcionales
window.Toast = {
    fire(text = 'Operación exitosa', icon = 'success', position = 'top', timer = 1500) {
        return ToastMixin.fire({
            icon: icon,
            text: text,
            timer: timer,
            position: position,
        });
    }
};